import { Schema } from "@effect/schema";
import { Amount, Usd } from "@silo/types";

export type RevenueData = typeof RevenueData.Type;
export type RevenueDataEncoded = typeof RevenueData.Encoded;

export const RevenueData = Schema.Struct({
  revenueBalance: Amount,
  revenueBalanceUsd: Usd,
}).annotations({ identifier: "RevenueData" });
